import React, {Component} from 'react';
import {Field} from 'formik';
import {parsers} from '@neosvoc/nv-platform-core-common';
import ImageUpload from './ImageUpload';

class ImageType extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
    }

    validate(value) {
        try {
            parsers.image(value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    render() {
        const {id, lang, required} = this.props;
        return (
            <div className="form-group">
                <Field name={id} type="file" className="custom-file-input form-control" validate={this.validate} required={required} accept="image/*"
                    lang={lang} component={ImageUpload} />
            </div>
        );
    }
}

export default ImageType;
